<template>
<div class="form">
<a-card :title="c_title">
    <v-gobackbutton v-show="isGuide != 'process'" slot="extra" >返回</v-gobackbutton>
        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item ref="signname" label="ali短信服务签名" prop="signname">
                <a-input
                    v-model="record.signname"
                     @blur="
                        () => {
                            $refs.signname.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>
            <a-form-model-item ref="signnamecode" label="签名对应编码" prop="signnamecode">
                <a-input
                    v-model="record.signnamecode"
                     @blur="
                        () => {
                            $refs.signnamecode.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>
            <a-form-model-item ref="servercode" label="服务商编码" prop="servercode">
                <a-input
                    v-model="record.servercode"
                     @blur="
                        () => {
                            $refs.servercode.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>
            <a-form-model-item ref="shopcode" label="商户编码" prop="shopcode">
                <a-input
                    v-model="record.shopcode"
                     @blur="
                        () => {
                            $refs.shopcode.onFieldBlur();
                        }
                        "
                />            

            </a-form-model-item>

            <a-form-model-item v-show="is_vue_task"  style="text-align: center">
                <a-button type="primary" @click="handleOk">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" @click="handleCancel">
                    取消
                </a-button>
            </a-form-model-item>
        </a-form-model>

 </a-card>
</div>
  
</template>
<script>
import { mapState } from "vuex";
const m_title = {
    'add':'新增签名',
    'edit':'编辑签名',
};
export default {
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            type:'',
            rules: {
                signname: [
                    { required: true, message: '请输入 ali短信服务签名', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                signnamecode: [
                    { required: true, message: ' 请输入 签名对应编码 ', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                servercode: [
                    { required: false, message: '请输入 服务商编码', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                shopcode: [
                    { required: false, message: ' 请输入商户编码 ', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal'
        };
    },
    props:{
        isGuide:String
    },
    computed: {
        ...mapState("smsmanager", {
            record: function(state) {
                console.log("state===>"+state);
                return this.action == "addSign" ? {} : state.record;
            }
        })
    },

    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    const { params } = this.$route;
                    if(params.action == 'editSign' || params.action == 'detailSign'){
                        //编辑
                        this.record.id = this.record.id;
                        this.$store
                            .dispatch({
                                type: "smsmanager/editSign",
                                params: this.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    console.log(response)
                                    this.handleCancel();
                                    this.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'addSign'){
                        //新增
                        this.$store
                            .dispatch({
                                type: "smsmanager/addSign",
                                params: this.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    console.log(response)
                                    this.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.type = params.action == "add";
        if (params.action != "add") {
            this.$store.dispatch({
                type: "smsmanager/detailSign",
                params: query,
                showMsg: false
            })
        }
        else{
            this.$store.dispatch({
                type: "smsmanager/getEmptySign",
                params: query,
                showMsg: false
            })  
        }
        this.is_vue_task = params.action != 'orgdetail'
        
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
